import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";

const PLATFORM_OPTIONS = [
    { value: "android", label: "Android" },
    { value: "ios", label: "iOS" },
    { value: "windows", label: "Windows" },
];

const MmpPlatformSelector = ({
    selectedPlatforms,
    onChange,
    disabled,
    error,
    label = "Platform",
}) => {
    const handleToggle = (platform) => {
        if (selectedPlatforms.includes(platform)) {
            onChange(selectedPlatforms.filter((p) => p !== platform));
        } else {
            onChange([...selectedPlatforms, platform]);
        }
    };

    return (
        <FormControl
            component="fieldset"
            className="mb-3"
            style={{ width: "100%" }}
            error={!!error}
        >
            <FormLabel component="legend" style={{ fontSize: "0.85rem" }}>
                {label} *
            </FormLabel>
            <FormGroup row>
                {PLATFORM_OPTIONS.map(({ value, label: optLabel }) => (
                    <FormControlLabel
                        key={value}
                        control={
                            <Checkbox
                                checked={selectedPlatforms.includes(value)}
                                onChange={() => handleToggle(value)}
                                disabled={disabled}
                                size="small"
                                inputProps={{
                                    "data-cy": `mmp-platform-${value}`,
                                }}
                            />
                        }
                        label={optLabel}
                    />
                ))}
            </FormGroup>
            {error && (
                <div className="fileUploadStyle">{error}</div>
            )}
        </FormControl>
    );
};

export default MmpPlatformSelector;
